<template>
  <ion-modal
      :is-open="element.common.config.alertModal.isOpen"
      :css-class="css_class"
      @didDismiss="element.common.config.alertModal.didDismissFun"
      showBackdrop='true'
  >
    <AlertModalTemplate :show_confirm="show_confirm" :confirm_text="confirm_text" :confirm_fun="confirm_fun" :text_align="text_align"></AlertModalTemplate>
  </ion-modal>
</template>

<script>
import AlertModalTemplate from "./AlertModalTemplate";
import {IonModal} from "@ionic/vue";

export default {
  name: "AlertModal",
  components: {
    AlertModalTemplate,
    IonModal,
  },
  props: {
    element: {type: Object},
    css_class: {type: String, default: 'alert-modal'},
    show_confirm: {type: String, default: ''},
    confirm_text: {type: String, default: ''},
    confirm_fun: {type: Function, default: function (){return}},
    text_align: {type: String, default: ''},

  }
}
</script>

<style scoped>

</style>